import { render, staticRenderFns } from "./layoutStyle35.vue?vue&type=template&id=15ebc784&scoped=true&"
import script from "./layoutStyle35.vue?vue&type=script&lang=ts&"
export * from "./layoutStyle35.vue?vue&type=script&lang=ts&"
import style0 from "./layoutStyle35.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./layoutStyle35.vue?vue&type=style&index=1&id=15ebc784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ebc784",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15ebc784')) {
      api.createRecord('15ebc784', component.options)
    } else {
      api.reload('15ebc784', component.options)
    }
    module.hot.accept("./layoutStyle35.vue?vue&type=template&id=15ebc784&scoped=true&", function () {
      api.rerender('15ebc784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/layoutStyle35.vue"
export default component.exports